import { render, staticRenderFns } from "./BackgroundSelector.vue?vue&type=template&id=3ac869b7&scoped=true"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSelector.vue?vue&type=style&index=0&id=3ac869b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac869b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac869b7')) {
      api.createRecord('3ac869b7', component.options)
    } else {
      api.reload('3ac869b7', component.options)
    }
    module.hot.accept("./BackgroundSelector.vue?vue&type=template&id=3ac869b7&scoped=true", function () {
      api.rerender('3ac869b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/BackgroundSelector.vue"
export default component.exports